<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="clientupdate_id" [ttModel]="edit.clientupdate_id" ttReadonly></tt-input>
        <tt-input ttLabel="remarks_id" [ttModel]="edit.remarks_id" ttReadonly></tt-input>
        <tt-input ttLabel="pst" [ttModel]="edit.pst" ttReadonly></tt-input>
        <tt-input ttLabel="p2_clientupdate_status" [ttModel]="edit.p2_clientupdate_status" ttReadonly></tt-input>
        <tt-input ttLabel="step" [ttModel]="edit.step" ttReadonly></tt-input>
        <tt-input ttLabel="steps" [ttModel]="edit.steps" ttReadonly></tt-input>
        <tt-datetime ttLabel="reg_datetime" [ttModel]="edit.reg_datetime" ttReadonly></tt-datetime>
        <tt-textarea ttLabel="last_statement" [ttModel]="edit.last_statement" ttReadonly></tt-textarea>
        <tt-button ttText="refresh" (ttClick)="refreshChanges()" [ttSpin]="refreshing" ttIcon="fas fa-sync"></tt-button>
    </tt-card>
</tt-page>
